import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT

//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/accountageset/list', qs.stringify(params))
}

export const getlistByCode = (params) => {
  return axios.post(root + '/set/accountageset/listByCode', qs.stringify(params))
}


//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/accountageset/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.get(root + '/set/accountageset/detail', {params: params})
}


//保存某一行的数据
export const saveData = (params) => {
    return axios.post(root + '/set/accountageset/save', qs.stringify(params))
}


//保存某一行的数据
export const checkCustomerserial = (params) => {
  return axios.post(root + '/salecontract/contractmanage/checkCustomerserial', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/accountageset.js